const formatadorData = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'UTC',
});

const formatadorHora = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'UTC',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

function horarioBrasilia(dataHora) {
  if (!dataHora) return null;

  const dataConvertida = new Date(dataHora);

  return Number.isNaN(dataConvertida.getTime()) ? null : dataConvertida;
}

export function obterDataHoraPartes(dataHora) {
  const dataConvertida = horarioBrasilia(dataHora);

  if (!dataConvertida) return { data: '', hora: '' };

  return {
    data: formatadorData.format(dataConvertida),
    hora: formatadorHora.format(dataConvertida),
  };
}

export function obterDataHora(dataHora) {
  const { data, hora } = obterDataHoraPartes(dataHora);

  if (!data || !hora) return dataHora || '';

  return `${data} ${hora}`;
}

export function obterAnoAtual() {
  return new Date().getUTCFullYear();
}
